import { render } from "./CardThirtySeven.vue?vue&type=template&id=71a1ff46"
import script from "./CardThirtySeven.vue?vue&type=script&lang=js"
export * from "./CardThirtySeven.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__